import React from 'react';

const AGB = () => (
  <div>
    <h2>Allgemeine Geschäftsbedingungen (AGB)</h2>
    <p><strong>Stand: Oktober 2025</strong></p>

    <h3>§ 1 Geltungsbereich</h3>
    <p>
      Diese AGB gelten für alle Bestellungen, die über die Webseite <strong>meincurryhouse.de</strong> aufgegeben werden.
      Es gelten ausschließlich diese AGB. Abweichende Bedingungen des Kunden finden keine Anwendung, es sei denn,
      Mein Curry House stimmt ausdrücklich schriftlich zu.
    </p>

    <h3>§ 2 Vertragspartner</h3>
    <p>
      Der Vertrag kommt zustande mit:<br />
      <strong>Mein Curry House</strong>, Inhaber [Name], Mainwasenweg 32, 60599 Frankfurt am Main.
    </p>

    <h3>§ 3 Angebot und Vertragsschluss</h3>
    <ol>
      <li>Die Darstellung der Produkte auf der Webseite stellt ein verbindliches Angebot dar.</li>
      <li>Der Vertrag kommt zustande, sobald der Kunde die Bestellung absendet und eine Bestätigung per E-Mail oder auf dem Bildschirm erhält.</li>
    </ol>

    <h3>§ 4 Preise</h3>
    <p>
      Alle Preise sind Endpreise in Euro und enthalten die gesetzliche Mehrwertsteuer.
      Lieferkosten und Mindestbestellwerte werden vor Abschluss der Bestellung angezeigt.
    </p>

    <h3>§ 5 Lieferung</h3>
    <ol>
      <li>Lieferung erfolgt ausschließlich in den auf der Webseite angegebenen Liefergebieten.</li>
      <li>Mindestbestellwert abhängig vom Liefergebiet (z.&nbsp;B. 15&nbsp;€, 20&nbsp;€ – genaue Werte siehe Webseite).</li>
      <li>Durchschnittliche Lieferzeit 40–60 Minuten, an Wochenenden bis zu 90 Minuten.</li>
      <li>Sollte ein Produkt nicht verfügbar sein, informieren wir den Kunden umgehend; geleistete Zahlungen werden erstattet.</li>
    </ol>

    <h3>§ 6 Zahlungsarten</h3>
    <p>Folgende Zahlungsarten werden angeboten:</p>
    <ul>
      <li>Barzahlung bei Lieferung,</li>
      <li>Kartenzahlung über Stripe,</li>
      <li>Online-Zahlung (Stripe-Checkout / PayPal via Stripe).</li>
    </ul>

    <h3>§ 7 Stornierung</h3>
    <ol>
      <li>Stornierungen sind innerhalb von 15 Minuten nach Bestellabsendung möglich.</li>
      <li>Danach ist eine Stornierung ausgeschlossen, da die Zubereitung beginnt.</li>
    </ol>

    <h3>§ 8 Widerrufsrecht</h3>
    <p>
      Gemäß §&nbsp;312g Abs.&nbsp;2 Nr.&nbsp;2 BGB besteht kein Widerrufsrecht für verderbliche Lebensmittel.
      Bei Falschlieferung oder Mängeln wird Ersatz oder eine Gutschrift angeboten.
    </p>

    <h3>§ 9 Allergene und Zusatzstoffe</h3>
    <p>
      Informationen zu Allergenen und Zusatzstoffen können telefonisch erfragt werden.
      Kunden sind verpflichtet, uns vor der Bestellung über Allergien oder Unverträglichkeiten zu informieren.
    </p>

    <h3>§ 10 Haftung</h3>
    <p>
      Mein Curry House haftet nur für Vorsatz und grobe Fahrlässigkeit. Für leichte Fahrlässigkeit nur bei Verletzung
      wesentlicher Vertragspflichten (Kardinalpflichten).
    </p>

    <h3>§ 11 Datenschutz</h3>
    <p>
      Es gilt die Datenschutzerklärung auf dieser Webseite. Details unter&nbsp;
      <a href="/datenschutzerklaerung">Datenschutzerklärung</a>.
    </p>

    <h3>§ 12 Gerichtsstand und anwendbares Recht</h3>
    <p>
      Es gilt deutsches Recht. Gerichtsstand ist Frankfurt am Main, soweit gesetzlich zulässig.
    </p>
  </div>
);

export default AGB;
